<template>
    <li :class="{ active: String($route.fullPath) == menu.path }">
        <a v-if="!menu.path">
            {{ menu.tag }}
            <i class="btn-dropdownicon fas fa-angle-down" aria-hidden="true"></i>
        </a>
        <router-link v-else :to="menu.path">
            {{ menu.tag }}
        </router-link>
        <ul v-if="hasChildren" class="menu-dropdown">
            <Menu
                v-for="(child, index) in menu.children"
                :key="index"
                :menu="child"                
            ></Menu>
        </ul>
    </li>
</template>

<script>
    export default {
        name: 'Menu',
        props: {
            menu: {
                type: Object,
                default: () => {}
            }
        },        
        computed: {
            hasChildren() {
                return this.menu.children && this.menu.children.length
            }
        },
    }
</script>
